import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useScreenSize() {
  const screenSize = ref(getSize());
  const innerWidth = ref(0);
  const innerHeight = ref(0);

  function getSize() {
    const width = window.innerWidth;
    if (width <= 640) return 'mobile';
    if (width <= 1024) return 'tablet';
    return 'desktop';
  }

  function resizeListener() {
    screenSize.value = getSize();
    innerWidth.value = window.innerWidth;
    innerHeight.value = window.innerHeight;
  }

  onMounted(() => {
    resizeListener();
    window.addEventListener('resize', resizeListener);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeListener);
  });

  return { screenSize, innerWidth, innerHeight };
}
